<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title">Products</h4>
      <div class="row mt-4">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Show&nbsp;
              <b-form-select
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select
              >&nbsp;entries
            </label>
          </div>
        </div>
        <!-- Search -->
        <div class="col-sm-12 col-md-6">
          <div
            id="tickets-table_filter"
            class="dataTables_filter text-md-right"
          >
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm ml-2"
              ></b-form-input>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>
      <!-- Table -->
      <div class="table-responsive mb-0">
        <b-table
          :items="tableData"
          :fields="fields"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-compare="tableSort"
          :filter="filter"
          :filter-included-fields="filterOn"
        >
          <template v-slot:cell(approved)="data">
                  <div
                    :id="`hoursApproved-${data.item.id}`"
                    style="display: inline-block"
                  >
                      <b-form-checkbox v-model="data.item.Approved" @change="approveTime(Date.now(), data.item)">
                    </b-form-checkbox>
                  </div>
                  <b-tooltip
                    :target="`hoursApproved-${data.item.id}`"
                    triggers="hover"
                    v-if="data.item.Approved && data.item.ApprovedBy"
                  >
                
                   {{
                      `Approved by ${
                      data.item.ApprovedBy.name
                    } on ${data.item.ApprovedTime
                      .toString()
                        .substring(0, 15)} at ${data.item.ApprovedTime
                      .toString()
                      .substring(16, 21)}`
                    }} 
                  </b-tooltip>
          </template>
          <template v-slot:cell(billable)="data">
            <b-badge :variant="data.value ? 'success' : 'danger'">{{
              data.value ? 'Yes' : 'No'
            }}</b-badge>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tableSort } from '../../helper/helpers.js';

export default {
  name: 'BillableProductsTable',
  components: {},
  props: {
    tableData: Array,
    sourceReport: String,
    allowApprovalProduct: {
    type: Boolean,
    default: false,
  },
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'Date',
      sortDesc: false,
      fields: [
        { key: 'Employee', sortable: true },
        { key: 'Date', sortable: true },
        { key: 'Customer', sortable: true },
        { key: 'Job', sortable: true },
        { key: 'Product', sortable: true },
        { key: 'Billable', sortable: true, class: 'billable' },
        { key: 'Quantity', sortable: true },
        { key: 'Rate', sortable: true },
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    tableSort: tableSort,
    approveTime(date, dataItem) {
      this.$emit('approve-change', date, dataItem);
    }

  },
  mounted() {
    if (this.sourceReport === 'employeeHours') {
      this.fields.push({ key: 'lineTotal', sortable: true });
    } else {
      this.fields.push({ key: 'PurchasePrice', sortable: true });
    }

    if (this.allowApprovalProduct) {
      this.fields.unshift({ key: 'Approved', sortable: true });
    }
  },
};
</script>
